import React from 'react';
import styles from './RoundButton.m.sass';

import cx from 'classnames';

export default function RoundButton({component = 'button', accent, small, extraSmall, children, ...rest}) {
  const Component = component;

  return (
    <Component
      className={cx(
        styles.roundButton,
        {[styles.roundButton__accent]: accent},
        {[styles.roundButton__small]: small},
        {[styles.roundButton__extraSmall]: extraSmall}
      )}
      {...rest}
    >
      <span className={styles.roundButton_wrapper}>
        <span className={styles.roundButton_icon}>
          {children}
        </span>
      </span>
    </Component>
  );
}



// WEBPACK FOOTER //
// ./components/roundButton/RoundButton.js